import { token } from '@betterment/samba-styled-system/tokens';
import { type XYChartTheme, buildChartTheme } from '@visx/xychart';

export type ThemeConfig = Parameters<typeof buildChartTheme>[0];

export const createSambaChartTheme = (theme?: Partial<ThemeConfig>): XYChartTheme => {
  return buildChartTheme({
    backgroundColor: 'transparent',
    colors: [
      token('colors.dataviz.blue.2'),
      token('colors.dataviz.teal.1'),
      token('colors.dataviz.orange.1'),
      token('colors.dataviz.purple.1'),
      token('colors.dataviz.navy.1'),
    ],
    gridColor: token('colors.border.weak'),
    gridColorDark: token('colors.border.weak'),
    svgLabelSmall: {
      fill: token('colors.text.weak'),
      fontSize: token('fontSizes.fontSize.25'),
      fontFamily: token('fonts.gtAmerica'),
      fontWeight: token('fontWeights.regular'),
    },
    svgLabelBig: {
      fill: token('colors.text.weak'),
      fontSize: token('fontSizes.fontSize.25'),
      fontFamily: token('fonts.gtAmerica'),
      fontWeight: token('fontWeights.regular'),
    },
    tickLength: 4,
    ...theme,
  });
};
